<template>
  <b-row v-if="items && items.length" style="justify-content: flex-start">
    <b-col v-for="item in items" :key="item.id" class="p-3" cols="12" sm="12" md="6" lg="6" xl="4">
      <BaseCardMc
        :learning-unit="item.learning_unit"
        :mode="item.mode"
        :lastest-evidence="item.evidenceSubmission"
        :status="item.status"
        :progress-percent="item.percent"
      ></BaseCardMc>
    </b-col>
  </b-row>

  <b-row v-else>
    <b-col cols="12" class="d-flex justify-content-center mb-2 mt-5">
      <div class="font-weight-bold h5">No micro-credentials to display</div>
    </b-col>
    <b-col cols="12" class="d-flex justify-content-center text-dark mb-4">
      Find micro-credentials that match your skill set.
    </b-col>
    <b-col cols="12" class="d-flex justify-content-center">
      <b-button variant="first" @click="goToLUExplorePage"> Explore </b-button>
    </b-col>
  </b-row>
</template>

<script>
import BaseCardMc from '@/components/base-components/BaseCardMc.vue';
export default {
  components: {
    BaseCardMc
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    goToLUExplorePage() {
      this.$router.push({ name: 'learning-unit' });
    }
  }
};
</script>
